import React from 'react';
import { ArrowRight, Phone } from 'lucide-react';
interface SpecialistsCTASectionProps {
  onOpenSampleModal?: () => void;
}
export function SpecialistsCTASection({
  onOpenSampleModal
}: SpecialistsCTASectionProps) {
  return <section className="py-20 bg-slate-50" data-id="element-506">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12" data-id="element-507">
        <div className="bg-[#0A1628] rounded-3xl p-10 md:p-16 relative overflow-hidden" data-id="element-508">
          {/* Subtle accent */}
          <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-[#0052CC]/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" data-id="element-509"></div>

          <div className="relative z-10 max-w-2xl mx-auto text-center" data-id="element-510">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight" data-id="element-511">
              Need expert advice on material selection?
            </h2>
            <p className="text-lg text-slate-300 mb-10 leading-relaxed" data-id="element-512">
              Our specialists have decades of experience solving industrial
              identification challenges. We're here to help you find the right
              solution.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-3" data-id="element-513">
              <button className="w-full sm:w-auto px-7 py-3.5 bg-[#0052CC] text-white font-bold rounded-full hover:bg-[#0040A0] transition-colors flex items-center justify-center group" data-id="element-514">
                <Phone className="mr-2 h-4 w-4" data-id="element-515" />
                Speak to our specialists
              </button>
              <button onClick={onOpenSampleModal} className="w-full sm:w-auto px-7 py-3.5 bg-white/10 border border-white/20 text-white font-bold rounded-full hover:bg-white hover:text-[#0A1628] transition-all duration-300 flex items-center justify-center" data-id="element-516">
                Request a sample pack
                <ArrowRight className="ml-2 h-4 w-4" data-id="element-517" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}